import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from '../new-navigation/rankings/data-widgets/data-widget.component';
import { MobileAppStiRanking } from '../new-navigation/rankings/models/mobileAppStiRanking';

@Component({
  selector: 'seller-risks',
  template: `
    <div class="d-flex flex-wrap flex-gap">
      <span
        *ngIf="data?.arbitrageRisk == '1'"
        class="badge risk-badge arbitrageRisk"
        data-toggle="tooltip"
        enTooltip
        title="Arbitrage"
        >Arbitrage</span
      >
      <span
        *ngIf="data?.sivtRisk == '1'"
        class="badge risk-badge sivtRisk"
        data-toggle="tooltip"
        enTooltip
        title="High SIVT"
        >High SIVT</span
      >
      <span
        *ngIf="data?.givtRisk == '1'"
        class="badge risk-badge givtRisk"
        data-toggle="tooltip"
        enTooltip
        title="High GIVT"
        >High GIVT</span
      >
    </div>
  `,
  styles: [
    `
      .flex-gap span {
        margin: 2px;
      }
      .risk-badge {
        background-color: #fa574b;
        color: #ffffff;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SellerRiskComponent extends DataWidgetComponent implements OnInit {
  @Input()
  data: MobileAppStiRanking;

  ngOnInit() {
    super.ngOnInit();
  }
}
